<script setup lang="ts">
import { computed } from 'vue';
import { DialogService } from '@/core/shared/dialog/dialog.service';
import BaseModal from '@/components/Shared/Modals/BaseModal.vue';

const dialogService = new DialogService();

const isOpen = computed(() => dialogService.goldUpgradeConfirmedModalProps?.isOpen || false);

function handleClose() {
  if (dialogService.goldUpgradeConfirmedModalProps) {
    dialogService.goldUpgradeConfirmedModalProps.isOpen = false;
  }
}
</script>

<template>
  <BaseModal
    :model-value="isOpen"
    :show-heading="false"
    :show-actions="false"
    max-width="560px"
    max-height="auto"
    @cancel="handleClose"
  >
    <!-- Close button -->
    <div class="absolute right-6 top-6">
      <button
        @click="handleClose"
        class="text-gray-500 hover:text-gray-700 transition-colors"
        aria-label="Close"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="text-center">
      <!-- Success Icon -->
      <div class="mb-6 flex justify-center">
        <img
          src="@/assets/svg/gold-upgrade-confirmed-icon.svg"
          alt="Gold upgrade success"
          width="96"
          height="96"
        />
      </div>

      <!-- Title -->
      <h2 class="mb-2 font-serif text-2xl font-extrabold text-highlight-1000">
        Gold upgrade confirmed!
      </h2>

      <!-- Description -->
      <p class="mb-8 text-shade-820">
        Your FactoryFix Gold upgrade is being processed. We'll have you up and running
        <span class="font-bold">within 1-2 business days.</span>
      </p>

      <!-- What happens next section -->
      <div class="mb-8 rounded-lg bg-gold-bg-light p-4">
        <p class="mb-3 font-bold text-gold-dark">What happens next:</p>
        <ul class="text-sm text-shade-900">
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>Our team will process your upgrade</span>
          </li>
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>You'll receive an email confirmation once complete</span>
          </li>
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>Your 30% job slot discount will be applied immediately</span>
          </li>
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>Billing will update with your next cycle</span>
          </li>
        </ul>
      </div>

      <!-- Actions -->
      <div class="flex justify-end gap-3">
        <button
          @click="handleClose"
          class="h-[36px] rounded-lg bg-white px-4 text-sm font-semibold text-shade-900"
        >
          Close
        </button>
        <button
          @click="handleClose"
          class="h-[36px] rounded-lg bg-gold px-4 text-sm font-semibold text-shade-900"
        >
          Got it
        </button>
      </div>
    </div>
  </BaseModal>
</template>

<style scoped>
/* Custom styles if needed */
</style>
